


















import { Component, Vue, Prop } from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import {ReportLabels} from '@/features/reports/models';

@Component
export default class ChartLabels extends Vue {
	@Prop() public reportId: string;
	@Getter public getReportLabels: (reportId: string) => ReportLabels;

	public get reportLabels(): ReportLabels {
		return this.getReportLabels(this.reportId);
	}

	public get labels() {
		if (this.reportLabels) {
			return this.reportLabels.reverse ? this.reportLabels.labels.slice().reverse() : this.reportLabels.labels;
		}
		return [];
	}

	public get scaleTitle() {
		return this.reportLabels ? this.reportLabels.scaleTitle : '-';
	}

	public get scaleValue() {
		return this.reportLabels ? this.reportLabels.scaleValue : '-';
	}
}
